export const TestIds = {
  itemWrapper: 'itemWrapper',
  linkWrapper: 'linkWrapper',
  toggle: 'expandablemenu-toggle',
} as const;
